import parseDynoTag from './parseDynoTag';

/**
 * Extracts the resolved paths (without filter syntax) from all DynoMark tags in a text string.
 * Used by consumers (e.g. Markdown.js) that need the raw field paths for purposes like
 * building react-hook-form watch lists.
 *
 * @param {string} text - text potentially containing `{{...}}` tags
 * @returns {string[]} array of path strings, e.g. ['user.name', 'variables.place']
 *
 * @example
 * extractDynoPaths('Hello {{user.name | upperCase}} and {{variables.place}}')
 * // → ['user.name', 'variables.place']
 */
const extractDynoPaths = (text) => {
	const matches = text.match(/\{\{(.*?)\}\}/g);
	if (!matches) {
		return [];
	}
	return matches.map((match) => parseDynoTag(match).path).filter(Boolean);
};

export default extractDynoPaths;
